module.exports = __webpack_public_path__ + "static/media/Monday_Step1_Image21.2f796670.jpg";